export default "__VITE_ASSET__D5ZkV8T5__"